import React, {Component} from 'react';
import { useState } from 'react';
import TutorialTile from './TutorialTile';
import TutorialCategoryBreifSummary from '../TutorialModel/Category/TutorialCategoryBreifSummary';
import './TutorialTileList.css';



export default class TutorialTileList extends Component
{
  /**
   *
   */
  constructor(props) {
    super(props);
    this.state = {
      TutorialCategoryBreifSummary: new TutorialCategoryBreifSummary(),
      isLoading: true,
      error: null
    };
  }

  render()
  {
  
    const TutorialCategoryBreifSummary = this.props.TutorialCategoryBreifSummary;
    if(!TutorialCategoryBreifSummary)
      {
         
        return(
          <div className='Tutorial-Tile-List'>
             <h2 className="section-title"> Data not found</h2>
          </div>
        )

      }
    return( 
    <section className="tutorial-list-section">
        <div className="tutorial-list-header">
           <h2>{TutorialCategoryBreifSummary.category}</h2>
         </div>

       <div className="tutorial-list">
             {
                  TutorialCategoryBreifSummary.tutorials.map((item,index)=>
                   (
                      <TutorialTile TutorialBreifSummary={item}/>
                   ))
              }
            
    </div>

</section>
    // <div className='Tutorial-Tile-List'>
    //   <h2 className="section-title">{TutorialCategoryBreifSummary.category}</h2>
    //   <div className="tutorials-grid">
    //      {
    //       TutorialCategoryBreifSummary.tutorials.map((item,index)=>
    //         (
    //           <TutorialTile TutorialBreifSummary={item}/>
    //       ))
    //      }
    //   </div>
    // </div>
 

);

  }

}
